export default {
  main: "http://localhost:5000",
};
